module.exports = [
  {
    "AgeGroup": "15-24 years",
    "Race": "Black, not Hispanic",
    "Year": "2000",
    "Rate": 183.07
  },
  {
    "AgeGroup": "15-24 years",
    "Race": "Black, not Hispanic",
    "Year": "2002-2004",
    "Rate": 193.43
  },
  {
    "AgeGroup": "15-24 years",
    "Race": "Black, not Hispanic",
    "Year": "2005-2007",
    "Rate": 245.9
  },
  {
    "AgeGroup": "15-24 years",
    "Race": "Black, not Hispanic",
    "Year": "2010",
    "Rate": 196.1
  },
  {
    "AgeGroup": "15-24 years",
    "Race": "Black, not Hispanic",
    "Year": "2011-2013",
    "Rate": 201.63
  },
  {
    "AgeGroup": "15-24 years",
    "Race": "Black, not Hispanic",
    "Year": "2014-2016",
    "Rate": 158.47
  },
  {
    "AgeGroup": "15-24 years",
    "Race": "Black, not Hispanic",
    "Year": "2018",
    "Rate": 146.4
  },
  {
    "AgeGroup": "15-24 years",
    "Race": "White, not Hispanic",
    "Year": "2000",
    "Rate": 88.13
  },
  {
    "AgeGroup": "15-24 years",
    "Race": "White, not Hispanic",
    "Year": "2002-2004",
    "Rate": 131.07
  },
  {
    "AgeGroup": "15-24 years",
    "Race": "White, not Hispanic",
    "Year": "2005-2007",
    "Rate": 113.53
  },
  {
    "AgeGroup": "15-24 years",
    "Race": "White, not Hispanic",
    "Year": "2010",
    "Rate": 97.53
  },
  {
    "AgeGroup": "15-24 years",
    "Race": "White, not Hispanic",
    "Year": "2011-2013",
    "Rate": 85.27
  },
  {
    "AgeGroup": "15-24 years",
    "Race": "White, not Hispanic",
    "Year": "2014-2016",
    "Rate": 82.87
  },
  {
    "AgeGroup": "15-24 years",
    "Race": "White, not Hispanic",
    "Year": "2018",
    "Rate": 104.15
  }
]
